var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 35",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5BF8640C-71AE-48C8-BA0C-0031C2B9E834")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.7133039,17.0519173 C35.3348138,16.3683794 35.2747975,15.32072 34.579301,14.7125099 L19.2565844,1.30506307 C18.561088,0.696852894 17.446036,0.70959379 16.7651803,1.33378597 L1.39038261,15.4273412 C0.709526972,16.0515334 0.676110058,17.0978516 1.316396,17.7633958 L1.70186401,18.1648458 C2.34136761,18.83039 3.37505668,18.9097412 4.0091957,18.3415419 L5.15822341,17.3125469 L5.15822341,32.3772044 C5.15822341,33.3014782 5.90714226,34.0497265 6.83074551,34.0497265 L12.8238845,34.0497265 C13.7474878,34.0497265 14.4964066,33.3014782 14.4964066,32.3772044 L14.4964066,21.838024 L22.1407211,21.838024 L22.1407211,32.3772044 C22.1274214,33.3008076 22.7882716,34.0490559 23.7118749,34.0490559 L30.0631001,34.0490559 C30.9867034,34.0490559 31.7356222,33.3008076 31.7356222,32.3765338 L31.7356222,17.5246716 C31.7356222,17.5246716 32.053027,17.8027361 32.4445302,18.1468521 C32.8353628,18.4902975 33.6562565,18.2149153 34.2777664,17.5307068 L34.7133039,17.0519173 Z",
    id: "home-icon-path1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-1-Shows",
    transform: "translate(-402.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Navigation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons",
    transform: "translate(320.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-/-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_icon",
    transform: "translate(82.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "home-icon-mask1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#home-icon-path1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Home",
    fill: "#010002",
    fillRule: "nonzero",
    xlinkHref: "#home-icon-path1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Grey/0",
    mask: "url(#home-icon-mask1)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home_icon.e3fa87fc.svg";
export { ForwardRef as ReactComponent };